import { render, staticRenderFns } from "./statsStaff.vue?vue&type=template&id=7e7c4e3e&"
import script from "./statsStaff.vue?vue&type=script&lang=js&"
export * from "./statsStaff.vue?vue&type=script&lang=js&"
import style0 from "./statsStaff.vue?vue&type=style&index=0&scopped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports